import { withEvents } from './with-events';

/**
 *
 * @param {typeof LitElement} Component
 * @param {(e: Event, thisArg: any) => any} handler
 * @returns {Enchanced}
 */
export const withCallbackOnEsc = (Component, handler) =>
  withEvents(Component, [
    {
      event: 'keyup',
      handler: (e, thisArg) => handleEscPress(e, () => handler(e, thisArg)),
      params: { element: 'self' },
    },
  ]);

/**
 *
 * @param {KeyboardEvent} e
 * @param {Function} handler
 */
export function handleEscPress(e, handler) {
  if (e.keyCode !== 27) return;

  handler();
}
